var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaWunderhebung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f4d0a6;}.cls-3{fill:#f1c693;}.cls-4{fill:#ff9a1f;}.cls-5{fill:#e6af78;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.71,38.18,38.18,10.71a9.25,9.25,0,0,1,13.08,0l98,98a9.25,9.25,0,0,1,0,13.08l-27.47,27.47a9.25,9.25,0,0,1-13.08,0l-98-98A9.25,9.25,0,0,1,10.71,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.29,108.74l-98-98a9.25,9.25,0,0,0-13.08,0l-10,10a9.25,9.25,0,0,1,13.08,0L110.53,90,80,120.55l3.24,3.24,28.42-28.42a3,3,0,0,1,4.22,0l23.39,23.39a9.25,9.25,0,0,1,0,13.08l10-10A9.25,9.25,0,0,0,149.29,108.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "10.71 38.18 28.16 20.73 10.71 38.18 10.71 38.18"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 118.57,
    cy: 96.87,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 126.99,
    cy: 105.28,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 135.4,
    cy: 113.7,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 111.34,
    cy: 104.1,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 119.75,
    cy: 112.52,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 128.17,
    cy: 120.94,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 104.1,
    cy: 111.34,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 112.52,
    cy: 119.75,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 120.94,
    cy: 128.17,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 96.87,
    cy: 118.57,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 105.28,
    cy: 126.99,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 113.7,
    cy: 135.4,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 46.3,
    cy: 24.6,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 54.72,
    cy: 33.01,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 63.13,
    cy: 41.43,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 39.06,
    cy: 31.83,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 47.48,
    cy: 40.25,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 55.9,
    cy: 48.66,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 31.83,
    cy: 39.06,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 40.25,
    cy: 47.48,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 48.66,
    cy: 55.9,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 24.6,
    cy: 46.3,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 33.01,
    cy: 54.72,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 41.43,
    cy: 63.13,
    r: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.18,149.29,10.71,121.82a9.25,9.25,0,0,1,0-13.08l98-98a9.25,9.25,0,0,1,13.08,0l27.47,27.47a9.25,9.25,0,0,1,0,13.08l-98,98A9.25,9.25,0,0,1,38.18,149.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.29,38.18,139.15,28a9.24,9.24,0,0,1,0,13.07l-98,98a9.24,9.24,0,0,1-13.07,0l10.14,10.14a9.25,9.25,0,0,0,13.08,0l98-98A9.25,9.25,0,0,0,149.29,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.19,105.52,54.48,92.81a10,10,0,0,1,0-14.18L78.63,54.48a10,10,0,0,1,14.18,0l12.71,12.71a10,10,0,0,1,0,14.18L81.37,105.52A10,10,0,0,1,67.19,105.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 96.87,
    cy: 41.43,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 105.28,
    cy: 33.01,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 113.7,
    cy: 24.6,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 104.1,
    cy: 48.66,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 112.52,
    cy: 40.25,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 120.94,
    cy: 31.83,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 111.34,
    cy: 55.9,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 119.75,
    cy: 47.48,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 128.17,
    cy: 39.06,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 118.57,
    cy: 63.13,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 126.99,
    cy: 54.72,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 135.4,
    cy: 46.3,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 24.6,
    cy: 113.7,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 33.01,
    cy: 105.28,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 41.43,
    cy: 96.87,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 31.83,
    cy: 120.94,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 40.25,
    cy: 112.52,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 48.66,
    cy: 104.1,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 39.06,
    cy: 128.17,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 47.48,
    cy: 119.75,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 55.9,
    cy: 111.34,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 46.3,
    cy: 135.4,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 54.72,
    cy: 126.99,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 63.13,
    cy: 118.57,
    r: 2.33
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaWunderhebung);
export default __webpack_public_path__ + "static/media/ka_wunderhebung.73486a99a005b678cafc8c788e56c6be.svg";
export { ForwardRef as ReactComponent };